/**
 * @param {Editor} editor
 */
function register(editor) {
    function template(title = '<h5>title</h5>', content = '<p>content</p>') {
        const style = 'style="background:white;margin-bottom:5px;padding-left:10px;border-radius: 5px;border: 1px solid rgb(212, 220, 233)"';
        return `
            <div class="d-accordion_item" contentEditable="false" style="padding:5px;background: rgba(224, 233, 245, 0.3);border-radius: 5px;border: 1px solid rgb(212, 220, 233);">
                <div contentEditable="true" ${style} class="d-accordion_title" >
                    ${title}
                </div>
                <div contentEditable="true" ${style} class="d-accordion_content">
                    ${content}
                </div>
            </div>
        `;
    }

    function templateClean(title = '<h5>title</h5>', content = '<p>content</p>', groupIndex = '0') {
        const randId = `a${Math.random().toString(36).substr(2, 10)}`;
        return `
            <div class="d-accordion_item">
                <div class="d-accordion_title-container" for-accordion-group="${groupIndex}" hide-for="${randId}">
                    <div class="d-accordion_title">
                        ${title}
                    </div>
                    <svg class="d-accordion_icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                    </svg>              
                </div>
                <div class="d-accordion_content hide" hide-name="${randId}">
                    ${content}
                </div>
            </div>
        `;
    }

    function updateExistingTemplates(html, clean) {
        const temp = document.implementation.createHTMLDocument('temp');
        temp.body.innerHTML = html;
        const els = temp.querySelectorAll('.d-accordion_item');
        if (els.length === 0) return html;

        // group related accordion items
        let groupIndex = 0;
        let trigger = false;
        Array.from(temp.body.children).forEach(a => {
            if (a.classList && a.classList.contains('d-accordion_item')) {
                a.setAttribute('group-index', groupIndex);
                trigger = true;
            } else if (trigger) {
                groupIndex += 1;
                trigger = false;
            }
        });

        els.forEach(a => {
            const titleEl = a.querySelector('.d-accordion_title');
            const contentEl = a.querySelector('.d-accordion_content');
            const title = titleEl ? titleEl.innerHTML : '<h5>title</h5>';
            const content = contentEl ? contentEl.innerHTML : '<p>content</p>';
            const index = a.getAttribute('group-index');

            if (!clean) {
                a.outerHTML = template(title, content, index);
            } else {
                a.outerHTML = templateClean(title, content, index);
            }
        });

        return temp.body.innerHTML;
    }

    editor.ui.registry.addButton('documentaccordion', {
        text: 'Accordion',
        onAction() {
            editor.insertContent(template());
        },
    });

    editor.on('SetContent', e => {
        if (e.no_events) return;
        const content = editor.getContent();
        const updated = updateExistingTemplates(content, false);
        if (content !== updated) {
            editor.setContent(updated, {no_events: true});
        }
    });

    editor.on('PostProcess', e => {
        e.content = updateExistingTemplates(e.content, true);
    });
}

/**
 * @return {register}
 */
export function getPlugin() {
    return register;
}
